import React, { useRef, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { AppContext } from "./index";
import { bkSubMain, SInput } from "./general"
import Boton from "./Boton"

export default function Login({ setLoginOK, setLogin }) {
    let { firebase, usrLogged } = useContext(AppContext);
    let history = useHistory();

    const email = useRef("");
    const passw = useRef("");

    useEffect(() => {
        let storedUser = JSON.parse(localStorage.getItem("OneShotUser"));
        email.current.value = storedUser !== null ? storedUser.email : "";
    }, []);

    function validarLogin() {
        let u = firebase.usuarioEmail(email.current.value);
        if (u) {
            if (passw.current.value === u.passw) {
                document.getElementById("htmlLogin").innerHTML = u.nombre;
                email.current.value = "";
                passw.current.value = "";
                localStorage.setItem("OneShotUser", JSON.stringify(u));
                usrLogged.logIN(u, firebase.permisos(u.rol));
                setLoginOK(true)
                setLogin(false)
                history.push("/");
            } else {
                alert("Contraseña incorrecta");
                setLoginOK(false)
            }
        } else {
            alert("Usuario incorrecto");
            setLoginOK(false)
        }
    }

    return (
        <div style={Slogin}>
            <input style={{ ...SInput, marginBottom: "10px" }} type="email" placeholder="Ingrese email" autoFocus ref={email}></input>
            <input style={{ ...SInput, marginBottom: "10px" }} type="password" placeholder="Ingrese contraseña" autoComplete="off" ref={passw}></input>
            <Boton accion={() => validarLogin()} texto={"Entrar"} change={true} />
            <div style={Sacciones}>
                <div onClick={(c) => c.currentTarget.style.color = "red"}>
                    Resetear contraseña
                </div>
            </div>
        </div>
    )
}

const Slogin = {
    display: "flex",
    flexDirection: "column",
    padding: "20px",
    position: "fixed",
    left: "80%",
    top: "8vh",
    borderRadius: "5px",
    background: bkSubMain,
    width: "18vw",
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
}

const Sacciones = {
    marginTop: "10px",
    textAlign: "center",
    fontSize: "1.5vh",
    color: "black",
    cursor: "pointer"
}